<template>
  <slot class="text-[11px] leading-4 font-semibold tracking-[0.5%]" />
</template>
